import React from "react";
import Post from "./Post";

const PostContainer = () => {
  return (
    <div className="p-2 min-h-screen">
      <Post />
    </div>
  );
};

export default PostContainer;
